export default __webpack_public_path__ + "static/media/picture1.9dfc15d3.png";